var map = {
	"./1AGP.png": 47278,
	"./2AGP.png": 65057,
	"./3AGP.png": 55052,
	"components/Catalog/AGP/img/glass/pr/prPlusSilver/1AGP.png": 47278,
	"components/Catalog/AGP/img/glass/pr/prPlusSilver/2AGP.png": 65057,
	"components/Catalog/AGP/img/glass/pr/prPlusSilver/3AGP.png": 55052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41861;